import { CheckoutService } from 'services/checkout.service';
import { ApiService } from 'services/api.service';
import { AddressVerificationService } from 'services/addressVerification.service';

import { AddressForm } from 'components/addressForm/addressForm';
import { SaveAndCancel } from 'components/saveAndCancel/saveAndCancel';
import { AddressVerificationForm } from 'components/addressVerificationForm/addressVerificationForm';

import template from './addShippingAddress.html';
import './addShippingAddress.scss';

export const AddShippingAddress = angular
    .module('checkout.components.editAccountContactAndDelivery.addShippingAddress', [
        AddressVerificationForm,
        AddressVerificationService,
        CheckoutService,
        ApiService,
        AddressForm,
        SaveAndCancel
    ]).component('addShippingAddress', {
        template,
        bindings: {
            onAddressSaved: '<',
            onCancelClicked: '&',
            isShippingRequired: '<',
            useAddressVerification: '<',
            useNewCarts: '<'
        },
        controller: class AddShippingAddressCtrl {
            constructor(apiService, checkoutService, addressVerificationService) {
                this.apiService = apiService;
                this.checkoutService = checkoutService;
                this.addressVerificationService = addressVerificationService;

                this.updateAddress = this.updateAddress.bind(this);
            }

            $onInit() {
                this.address = { address: {} };
            }

            onSaveClicked() {
                if (this.addShippingAddressForm.$invalid) {
                    this.checkoutService.forceFormValidation(this.addShippingAddressForm['$ctrl.addressForm']);
                    return;
                }
                this.isAddressSaving = true;

                if (this.useNewCarts && this.useAddressVerification) {
                    this.addressVerificationService.verifyAddress(this.address.address)
                        .then(({ verified, changes, recommendations }) => {
                            if (!verified || changes) {
                                this.isAddressSaving = false;

                                this.showAddressSuggestion = true;
                                this.addressRecommendations = recommendations;
                                this.addressChanges = changes;
                            } else {
                                this.updateShippingAddress();
                            }
                        });
                } else {
                    this.updateShippingAddress();
                }
            }

            updateAddress(newAddress) {
                this.showAddressSuggestion = false;
                this.addressRecommendations = null;
                this.addressChanges = null;

                if (newAddress) {
                    this.address.address = { ...this.address.address, ...newAddress };
                    this.isAddressSaving = true;
                    this.updateShippingAddress();
                }
            }

            updateShippingAddress() {
                this.apiService.account.shippingAddress.add(this.address).then((address) => {
                    return this.onAddressSaved(address);
                }).finally(() => {
                    this.isAddressSaving = false;
                });
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/editAccountContactAndDelivery/addShippingAddress/addShippingAddress.js